import { render, staticRenderFns } from "./MoreVertBtn.vue?vue&type=template&id=51a06a64&scoped=true&"
import script from "./MoreVertBtn.vue?vue&type=script&lang=ts&"
export * from "./MoreVertBtn.vue?vue&type=script&lang=ts&"
import style0 from "./MoreVertBtn.vue?vue&type=style&index=0&id=51a06a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a06a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
